<one-table>

  <one-table-content>
    <mat-table [dataSource]="dataSource" matSort>
      <ng-container matColumnDef="select">
        <mat-header-cell *matHeaderCellDef>
          <mat-checkbox
            (change)="$event ? masterToggle() : null"
            [checked]="selection.hasValue() && isAllSelected()"
            [indeterminate]="selection.hasValue() && !isAllSelected()"
          >
          </mat-checkbox>
        </mat-header-cell>
        <mat-cell *matCellDef="let row">
          <mat-checkbox
            (change)="$event ? selection.toggle(row) : null; selectedRow = row"
            (click)="$event.stopPropagation()"
            [checked]="selection.isSelected(row)"
            [unchecked]="isUnChecked()"           
          >
          </mat-checkbox>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="customerID">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="nat-customerId-column" >Account ID</mat-header-cell>
        <mat-cell *matCellDef="let element; let index = index" class="nat-customerId-column-cell">
         <div *ngIf="element.customerID || element.customerID == null; else natEditablecustomerID" class="truncate-text" [title]="element.customerID">
              {{element.customerID}}
            </div>
            <ng-template #natEditablecustomerID>
              <mat-form-field appearance="outline" class="noadd-template-txt-box nat-customerId-column-input" oneFormField  >              
                <input matInput placeholder="Enter text..."   [formControl]="getControl(index, 'customerID')" min="5" max="250" required/>
              </mat-form-field>                      
            </ng-template>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="customerName">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="nat-customername-column" >Account Name</mat-header-cell>
        <mat-cell *matCellDef="let element; let index = index" class="nat-customername-column-cell">          
            <div *ngIf="element.customerName || element.customerName == null; else natEditablecustomerName" class="truncate-text" [title]="element.customerName">
              {{element.customerName}}
            </div>
            <ng-template #natEditablecustomerName>
              <mat-form-field appearance="outline" class="noadd-template-txt-box nat-customername-column-input" oneFormField>              
                <input matInput placeholder="Enter text..."   [formControl]="getControl(index, 'customerName')" min="5" max="250" required/>
              </mat-form-field>           
            </ng-template>          
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="customerContactName">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="nat-customercontactname-column">Account Contact Name</mat-header-cell>
        <mat-cell *matCellDef="let element; let index = index" class="nat-customercontactname-column-cell">
         
          <div *ngIf="element.customerContactName || element.customerContactName == null; else natEditablecustomerContactName" class="truncate-text" [title]="element.customerContactName">
            {{element.customerContactName}}
          </div>
          <ng-template #natEditablecustomerContactName>
            <mat-form-field appearance="outline" class="noadd-template-txt-box nat-customercontactname-column-input" oneFormField>              
              <input matInput placeholder="Enter text..."  [formControl]="getControl(index, 'customerContactName')" min="5" max="250" required/>
            </mat-form-field>           
          </ng-template>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="customerContactEmail">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="nat-customercontactemail-column">Account Contact Email</mat-header-cell>
        <mat-cell *matCellDef="let element; let index = index" class="nat-customercontactemail-column-cell">
          
        
           <div *ngIf="element.customerContactEmail || element.customerContactEmail == null; else natEditablecustomerContactEmail" class="truncate-text" [title]="element.customerContactEmail">
            {{element.customerContactEmail}}
          </div>
          <ng-template #natEditablecustomerContactEmail>
            <mat-form-field appearance="outline" class="noadd-template-txt-box nat-customercontactemail-column-input" oneFormField>              
              <input type="text" matInput placeholder="Enter email..." [formControl]="getControl(index, 'customerContactEmail')" min="5" max="250" required  />
            </mat-form-field>           
          </ng-template>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="source">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="nat-source-column">Source</mat-header-cell>
        <mat-cell *matCellDef="let element; let index = index" class="nat-source-column-cell">
          <mat-chip *ngIf="element.source || element.source == null; else natEditablesource" class="nat-list-source-chip nat-truncate-text"  oneChip oneChipAppearance="outline" class="truncate-text" [title]="element.source">
            {{element.source}}
          </mat-chip>
          <ng-template #natEditablesource>
            <mat-form-field appearance="outline" class="noadd-template-txt-box nat-source-column-input" oneFormField>              
              <input matInput placeholder="Enter text..."   [formControl]="getControl(index, 'source')" min="5" max="250" required/>
            </mat-form-field>           
          </ng-template>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="iconSets">
        <mat-header-cell style="display: none;" *matHeaderCellDef ></mat-header-cell>
        <mat-cell *matCellDef="let element; let inx = index" style="display: contents;">
          <button mat-icon-button one-icon-button matSuffix *ngIf="element.iconSets === 'yes-No-icon'" [disabled] ="controls.controls[inx].status == 'VALID'? false:true" (click)="addNewNotificationRecipient(element, inx,'yes')">
              <mat-icon i18n-aria-label="@@buttons.icon-buttons-example-button" matSuffix class="done-icon">yes</mat-icon>
          </button>
          <button mat-icon-button one-icon-button matSuffix *ngIf="element.iconSets === 'yes-No-icon'" (click)="addNewNotificationRecipient(element, inx,'no')">
            <mat-icon i18n-aria-label="@@buttons.icon-buttons-example-button" matSuffix class="done-icon">no</mat-icon>
          </button>
        </mat-cell>
      </ng-container>
      <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
      <mat-row
        *matRowDef="let row; columns: displayedColumns"
        [ngClass]="{ checked: selection.isSelected(row) }"
        class="one-element-row add-recipient-template"
      ></mat-row>
    </mat-table>
  </one-table-content>
</one-table>
<p class="add-recipient-text" [ngStyle]="{'display':controls.value.length>0?'none':'block'}">Click on “Add recipients” to add additional recipients.</p>